import { render, staticRenderFns } from "./FollowUpPatientStep3Component.vue?vue&type=template&id=336d8b90&scoped=true&"
import script from "./FollowUpPatientStep3Component.vue?vue&type=script&lang=js&"
export * from "./FollowUpPatientStep3Component.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpPatientStep3Component.vue?vue&type=style&index=0&id=336d8b90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336d8b90",
  null
  
)

export default component.exports